"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.DeviceListQuery = exports.DeviceListItem = exports.ConsumableItem = exports.AlarmItem = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const geography_1 = require("../../../../geography");
const schema_1 = require("../../../../schema");
const Device = __importStar(require("../../../device"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const device_filters_1 = require("./device-filters");
const Error = __importStar(require("./error"));
const Tenant = __importStar(require("./tenant"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Devices';
exports.AlarmItem = effect_1.Schema.Struct({
    tag: Device.Capability.Alarm.AlarmTag,
    severity: Device.Capability.Alarm.Severity,
    domain: Device.Capability.Alarm.AlarmDomain,
    description: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.AlarmItem`,
    description: 'One active alarm attached to a device',
});
exports.ConsumableItem = effect_1.Schema.Struct({
    identifier: effect_1.Schema.String,
    label: effect_1.Schema.String,
    level: effect_1.Schema.Number.pipe(effect_1.Schema.between(0, 100)),
    status: Device.Capability.Consumable.Condition,
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumableItem`,
    description: 'One consumable slot mounted on a device',
});
exports.DeviceListItem = effect_1.Schema.Struct({
    id: Device.Class.Common.Id,
    model: Device.Class.Common.ModelCode,
    productLabel: effect_1.Schema.String,
    manufacturingSerialNumber: effect_1.Schema.NullOr(schema_1.PrintString),
    sku: effect_1.Schema.NullOr(schema_1.PrintString),
    assetTag: effect_1.Schema.NullOr(schema_1.PrintString),
    installationAddress: geography_1.Address,
    connectivity: effect_1.Schema.NullOr(Device.Class.Base.Connectivity),
    connectionStatus: Device.Class.Base.ConnectionState,
    location: effect_1.Schema.NullOr(geography_1.GeoPosition),
    alarms: effect_1.Schema.Array(exports.AlarmItem),
    filters: effect_1.Schema.Array(exports.ConsumableItem),
    co2: effect_1.Schema.Array(exports.ConsumableItem),
    enhancements: effect_1.Schema.Array(exports.ConsumableItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceListItem`,
    description: 'One device row with full status details for the dashboard unit-cards widget',
});
exports.DeviceListQuery = effect_1.Schema.Struct({
    ...device_filters_1.CommonDeviceFilterFields,
    search: effect_1.Schema.optionalWith(effect_1.Schema.Trim.pipe(effect_1.Schema.nonEmptyString()), {
        exact: true,
    }),
    page: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.positive(), effect_1.Schema.int()), {
        exact: true,
        default: () => 1,
    }),
    size: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 100)), {
        exact: true,
        default: () => 20,
    }),
    alarmDomains: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmDomain), {
        exact: true,
        default: () => [],
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceListQuery`,
    description: 'Query parameters for fetching a device list.',
});
const getDevices = platform_1.HttpApiEndpoint.get('getDevices') ``
    .middleware(Tenant.Middleware)
    .setUrlParams(exports.DeviceListQuery)
    .addSuccess(Protocol.paginatedResponseBodySuccess(exports.DeviceListItem), {
    status: 200,
})
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Devices')
    .annotate(platform_1.OpenApi.Description, 'Paginated list of devices with full status details (alarms, filters, CO2, enhancements) for the dashboard unit-cards widget.');
exports.Spec = platform_1.HttpApiGroup.make('devices')
    .middleware(authorization_1.UserAuthorization)
    .add(getDevices)
    .prefix('/devices')
    .annotate(platform_1.OpenApi.Title, 'Devices')
    .annotate(platform_1.OpenApi.Description, 'Device list endpoints');
//# sourceMappingURL=devices.js.map